import { lazy } from "react";
// Stage 2 Guide — guía en-app de los módulos Billing V2 (Etapa 2): qué hace
// cada módulo, cómo se usa paso a paso y qué entrega, bilingüe EN/ES.
// El contenido vive en content/modules/*.js; la fuente editorial es
// docs/modulos/BillingV2/MANUAL_DE_USO.md.

const Stage2GuidePage = lazy(() => import("./pages/Stage2GuidePage"));

export const stage2GuideRoutes = [
  {
    path: "/stage2-guide",
    element: <Stage2GuidePage />,
  },
];
